export default "__VITE_ASSET__960e0fee__"